import style from './style.module.scss';
import {FC} from 'react';
import classNames from 'classnames';
import {IDataAutotestProps, TPropsWithClassName} from 'core/types';
import Icon from 'components/Icon';

export const BySimpleInfo: FC<IDataAutotestProps & unknown & TPropsWithClassName> = ({
    dataAutotestTarget,
    dataAutotestTargetId,
    className,
    ...props
}) => {
    return (
        <div {...props} className={classNames(style.bonusesNotification, 'bonuses-info', className)}>
            <Icon className={style.infoIcon} icon={'info-filled'} />
            <div
                className={style.text}
                data-autotest-target={dataAutotestTarget}
                data-autotest-target-id={dataAutotestTargetId}
            >
                В этой винотеке нельзя списать и&nbsp;начислить бонусы по программе лояльности.
            </div>
        </div>
    );
};
